var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2461 13.7212C11.6593 13.7512 12.0184 13.4405 12.0483 13.0274L12.5358 6.29499C12.5657 5.88185 12.255 5.52269 11.8419 5.49278C11.4288 5.46287 11.0696 5.77353 11.0397 6.18666L10.6064 12.171L4.62207 11.7377C4.20894 11.7078 3.84978 12.0184 3.81987 12.4316C3.78996 12.8447 4.10062 13.2039 4.51375 13.2338L11.2461 13.7212ZM0.389299 1.5053L10.733 13.4638L11.8675 12.4826L1.52379 0.524002L0.389299 1.5053Z",
    fill: "#262B41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.382ab0bd13027c46e4305c4fd16fb692.svg";
export { ForwardRef as ReactComponent };